import React from 'react';
import {
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { useMenu } from 'hooks';

const CoinRateItem = ({ coinRate, handleClick, handleEditClick }) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(coinRate, e)}>Edit</MenuItem>
		</Menu>
	);

	return (
		<TableRow
			hover
			onClick={() => handleClick(coinRate)}
			sx={{ cursor: 'pointer' }}
		>
			<TableCell>
				<Typography variant="primary.text">{coinRate.name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{coinRate.coins}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{coinRate.xp}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default CoinRateItem;
